/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class AssessmentsRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  model() {
    let store = this.store;
    return hash({
      assessments: store.findAll('assessments/assessment'),
      modules: store.findAll('assessments/module'),
      categories: store.findAll('assessments/category'),
      gradeschedules: store.findAll('assessments/grade-schedule'),
      pages: store.findAll('posts/page'),
    });
  }
}
